import { useTranslation } from "react-i18next";
import { Warehouse } from "lucide-react";
import { Button } from "components/common/Button";
import type { RoomsControlProps } from "./types";

export const RoomsControl = ({
  count,
  canEdit,
  onOpenPanel,
}: RoomsControlProps) => {
  const { t } = useTranslation();

  const hasRooms = count > 0;

  if (!canEdit && !hasRooms) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onOpenPanel}
      startAdornment={<Warehouse className="w-3.5 h-3.5" />}
      className="shrink-0"
    >
      {t("smartSurveyor.rooms.roomsButton")}
      {hasRooms && (
        <span className="px-1.5 rounded-full bg-gray-100 text-gray-700">
          {count}
        </span>
      )}
    </Button>
  );
};
